import { useState } from 'react';
import { Tooltip } from 'uiKit/atoms/Tooltip/Tooltip';
import { Button } from 'uiKit/atoms/Button/Button';
import { toast } from 'react-toastify';
import cn from 'classnames';
import { DeleteFilled } from '@ant-design/icons';

import styles from './ImageCard.module.scss';

const ImageCard = props => {
  const { imagesList, file, deleteImage, handlePickMainImage, mainImageIndex } = props;
  const [isMouseEntered, setIsMouseEntered] = useState(false);
  const imagePath = file.thumbUrl || file.fileName;
  const imageName = file.name || 'lot-image';
  const arrayIndex = imagesList.findIndex(img => img.uid === file.uid);

  const handleClickCoverButton = () => handlePickMainImage(imagesList, file.uid, arrayIndex);

  const handleDeleteButtonClick = () => {
    const imgToDelete = arrayIndex === mainImageIndex;
    if (imgToDelete && imagesList.length > 1) {
      toast.error('You trying to delete the main image. Pick another image as main and try again');
      return;
    }
    deleteImage(file.uid, file.id);
  };

  return (
    <div
      className={styles.bns3_image_container}
      onMouseEnter={() => setIsMouseEntered(true)}
      onMouseLeave={() => setIsMouseEntered(false)}
      id={file.uid}
    >
      <img src={imagePath} alt={imageName} className={styles.bns3_image} />
      <div className={styles.bns3_image_overlay}>
        {isMouseEntered && (
          <Button
            variant="text"
            className={cn(styles.bns3_image_button, styles.bns3_image_cover_button)}
            onClick={handleClickCoverButton}
          >
            {arrayIndex === mainImageIndex ? 'Main image' : 'Make a cover'}
          </Button>
        )}
        {isMouseEntered && (
          <Tooltip title="Delete">
            <Button
              onClick={handleDeleteButtonClick}
              className={cn(styles.bns3_image_button, styles.bns3_image_delete_button)}
            >
              <DeleteFilled />
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default ImageCard;
